import { isHotel, isTourOffer, isVillaOffer } from 'lib/offer/offerTypes'
import { TASTE_OF_GOLD_MIN_PRICE } from '../constants/tasteOfGoldConstants'

/**
 * Checks whether an offer is eligible for the Taste of Gold campaign.
 * Eligible offers must be an international Hotel, Villa, or Tour with a minimum price in AUD.
 *
 * @param offer - The offer to check
 * @param currency - The user's active currency
 * @param isInternational - Whether the offer is international (derived per offer type by the caller)
 * @param price - The relevant display price for the offer
 */
function isTasteOfGoldEligibleOffer(
  offer: App.AnyOffer,
  currency: string,
  isInternational: boolean,
  price: number,
): boolean {
  return (isHotel(offer) || isVillaOffer(offer) || isTourOffer(offer)) &&
    currency === 'AUD' &&
    isInternational &&
    price >= TASTE_OF_GOLD_MIN_PRICE
}

export default isTasteOfGoldEligibleOffer
